import 'magnific-popup'

$(function() {
  $(window).on('load', function() {
    if($('#slidekitDlAgreeModal').length) {
      $.magnificPopup.open({
        items: {src: '#slidekitDlAgreeModal'},
        mainClass: 'p-whiteBackModal',
        showCloseBtn: false,
        preloader: false,
        closeOnBgClick: false,
        fixedContentPos: true,
        enableEscapeKey: false,
        callbacks: {
          open: function(){
            $('body').css('overflow','hidden');
            $('body').css('height','100%');
            $('html').css('height','100%');
          },
          close: function(){
            $('body').css('overflow','auto');
            $('body').css('height','auto');
            $('html').css('height','auto');
          }
        }
      }, 0);

      // ロード時ちょい見え防止のためデフォルトでbodyにvisibility:hiddenを設定しているため以下で解除
      $('body').css('visibility','visible');
    }
  });

  $(document).on('click touchend','.js-slidekitDlAgreeModalClose',  function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});